export const ROUTE_SELLER = '/produtores/'
export const ROUTE_SELLER_INDEX = '/produtores'

export default { seller: ROUTE_SELLER, sellers: ROUTE_SELLER_INDEX }
